module.exports = __webpack_public_path__ + "img/bybit.5d9a74f6.png";